/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListCompany } from '../../models/api-response-list-company';

export interface GetAllCompanies$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function getAllCompanies(http: HttpClient, rootUrl: string, params: GetAllCompanies$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListCompany>> {
  const rb = new RequestBuilder(rootUrl, getAllCompanies.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListCompany>;
    })
  );
}

getAllCompanies.PATH = '/v1/api/ui/meta-pricing-analytics/companies';
